import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PathAlternate.svg",
  "use": "PathAlternate.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PathAlternate.svg\"><path d=\"M54,46a2,2,0,0,1-2,2H24a2,2,0,1,1,0-4H52A2,2,0,0,1,54,46ZM10,18a2,2,0,0,1,2-2H40a2,2,0,0,1,0,4H12A2,2,0,0,1,10,18Zm6,14h0a2,2,0,0,1,2-2H46a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2H18A2,2,0,0,1,16,32Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol